import { render, staticRenderFns } from "./CursoInduccion.vue?vue&type=template&id=022315ab&scoped=true"
import script from "./CursoInduccion.vue?vue&type=script&lang=js"
export * from "./CursoInduccion.vue?vue&type=script&lang=js"
import style0 from "./CursoInduccion.vue?vue&type=style&index=0&id=022315ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022315ab",
  null
  
)

export default component.exports